define('TescoMobile_Checkout/js/action/agreements-assigner',['jquery'], function ($) {
  'use strict';

  var agreementsConfig = window.checkoutConfig.checkoutAgreements;
  return function (aboutData) {
    let agreementForm, agreementData, agreementIds;
    if (!agreementsConfig.isEnabled) {
      return;
    }
    agreementForm = $('#about-before-continue div[data-role=checkout-agreements] input');
    agreementData = agreementForm.serializeArray();
    agreementIds = [];
    agreementData.forEach(function (item) {
      agreementIds.push(item.value);
    });
    aboutData.agreementIds = agreementIds;
  };
});

